import styled from '@emotion/styled';

export const Container = styled.div`
  width: 100%;
  padding: ${(props) => props.theme.spacing(2)};
  box-sizing: border-box;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: ${(props) => props.theme.spacing(2)};

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: 960px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (min-width: 1280px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;

export const UploadContainer = styled.div`
  min-height: 96px;
`;
